export default __webpack_public_path__ + "static/media/quickstart_quide_incompleted.5bd72b86.svg";